import * as React from 'react';

export default () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <defs id="defs14" />
    <rect
      y="0"
      width="70"
      height="70"
      rx="35"
      fill="#0088ff"
      id="rect2"
      x="0"
    />
    <path
      d="m 42.1115,43.607417 c -0.6573,0.2396 -1.3849,0.4015 -2.1947,0.4015 h -2.6994 c -1.7488,0 -3.2158,-0.6476 -3.6501,-1.5284 -8.9784,0.4015 -16.0673,5.5634 -16.0673,11.8912 0,0.3627 0.5164,0.6476 1.1737,0.6476 h 32.1346 c 0.6572,0 1.1736,-0.2849 1.1736,-0.6476 -0.0117,-4.7604 -4.0256,-8.8731 -9.8704,-10.7643 z"
      fill="#ffffff"
      id="path4"
    />
    <path
      d="m 36.7551,37.374917 h 2.7699 0.2288 c 1.8788,-1.1263 3.2999,-2.7853 4.1911,-4.8198 v -7.0844 -0.4481 c -1.4934,-4.0689 -5.3954,-6.9269 -9.8152,-6.9269 -4.2754,0 -8.1653,2.7126 -9.6707,6.6363 0.0722,0.2301 0.0722,0.4481 0.0722,0.7508 v 7.0844 c 1.5777,3.6209 5.0221,6.1761 9.1408,6.4062 0.7587,-0.993 1.8065,-1.5985 3.0831,-1.5985 z"
      fill="#ffffff"
      id="path6"
    />
    <path
      d="m 36.6174,43.149417 h 2.6201 c 0.5696,0 1.1392,-0.3667 1.3442,-0.8872 3.1213,-1.8456 5.4566,-4.8623 6.3793,-8.3878 0.638,-0.071 1.2759,-0.142 1.6974,-0.6625 0.5696,-0.5915 0.8543,-1.6208 0.8543,-3.5373 0,-3.3835 -0.7746,-4.046 -2.5517,-4.1998 -1.5606,-5.8206 -6.7324,-10.1623 -12.8269,-10.1623 -6.0945,0 -11.2663,4.3417 -12.827,10.1623 -1.629,0.142 -2.415,0.9583 -2.415,4.1998 0,1.9165 0.2164,2.9458 0.8544,3.5373 0.6379,0.6625 1.629,0.6625 2.5517,0.6625 0.3531,0 0.7063,-0.2958 0.7063,-0.7335 v -7.0627 c 0,-0.2248 -0.1367,-0.4378 -0.2848,-0.5206 1.4923,-5.158 6.0945,-8.8373 11.4827,-8.8373 5.4566,0 10.0702,3.8331 11.4828,8.9793 -0.0684,0.1419 -0.1367,0.2957 -0.1367,0.4377 v 7.0628 c 0,0.1419 0.0683,0.2957 0.1367,0.4377 -0.8544,2.9458 -2.6201,5.442 -5.1718,7.0627 -0.2848,-0.4377 -0.7063,-0.7334 -1.2759,-0.7334 h -2.6201 c -0.8543,0 -1.5606,0.7334 -1.5606,1.6207 0.0683,0.8282 0.7063,1.5616 1.5606,1.5616 z"
      fill="#ffffff"
      id="path8"
    />
  </svg>
);
